export default __webpack_public_path__ + "static/Compliance_1-f1cbc52045ff45e05e772c48d6210fa3.svg";